const defaultState = {
  notifications: [],
  hasNewNotifications: false
};

export default defaultState;
